import { NgModule } from '@angular/core';
import { FaqV2RoutingModule } from './faq-v2-routing.module';

@NgModule({
  imports: [FaqV2RoutingModule],
})
export class FaqV2Module {}
